@if (loading()) {
    @if (variant() === barChartVariantEnum.STACKED) {
        <div class="bar-chart-stacked" [style.gap.px]="rowGap()">
            @for (row of skeletonRows(); track row) {
                <div class="stacked-row">
                    <div class="stacked-label-line">
                        <span class="skeleton-text label-skeleton"></span>
                        <span class="skeleton-text value-skeleton"></span>
                    </div>
                    <span class="bar-chart-bar-track skeleton-bar"></span>
                </div>
            }
        </div>
    } @else {
        <div class="bar-chart-table" [style.gap.px]="rowGap()">
            <div class="bar-chart-header">
                <span class="bar-chart-label-col"></span>
                @for (column of skeletonColumns(); track column.key) {
                    <span class="bar-chart-value-col">
                        <span class="skeleton-text header-skeleton"></span>
                    </span>
                }
            </div>
            @for (row of skeletonRows(); track row) {
                <div class="bar-chart-row">
                    <span class="bar-chart-label-col">
                        <span class="skeleton-text label-skeleton"></span>
                    </span>
                    @for (column of skeletonColumns(); track column.key) {
                        <span class="bar-chart-value-col">
                            <span class="bar-chart-bar-track skeleton-bar"></span>
                            <span class="skeleton-text value-skeleton"></span>
                        </span>
                    }
                </div>
            }
        </div>
    }
} @else {
    @if (variant() === barChartVariantEnum.STACKED) {
        <div class="bar-chart-stacked" [style.gap.px]="rowGap()">
            @for (row of computedRows(); track row.label) {
                <div class="stacked-row">
                    @for (cell of row.cells; track cell.key) {
                        <div class="stacked-label-line">
                            <span class="stacked-label">{{ row.label }}</span>
                            <span class="stacked-percentage">{{ cell.formattedPercentage }}</span>
                        </div>
                        <span class="bar-chart-bar-track">
                            <span class="bar-chart-bar-fill" [style.width.%]="cell.percentage" [style.background-color]="cell.color"></span>
                        </span>
                    }
                </div>
            }
        </div>
    } @else {
        <div class="bar-chart-table" [style.gap.px]="rowGap()">
            <div class="bar-chart-header">
                <span class="bar-chart-label-col"></span>
                @for (column of computedColumns(); track column.key) {
                    <span class="bar-chart-value-col">{{ column.label }}</span>
                }
            </div>
            @for (row of computedRows(); track row.label) {
                <div class="bar-chart-row" [class.total-row]="row.isTotal">
                    <span class="bar-chart-label-col">{{ row.label }}</span>
                    @for (cell of row.cells; track cell.key) {
                        <span class="bar-chart-value-col">
                            <span class="bar-chart-bar-track">
                                <span
                                    class="bar-chart-bar-fill"
                                    [style.width.%]="cell.percentage"
                                    [style.background-color]="cell.color"
                                ></span>
                            </span>
                            <span class="bar-chart-percentage">{{ cell.formattedPercentage }}</span>
                        </span>
                    }
                </div>
            }
        </div>
    }
}
